import './styles/a.css'
import './styles/alert.css'
import './styles/avatar.css'
import './styles/badge.css'
import './styles/button.css'
import './styles/calendar.css'
import './styles/collapse.css'
import './styles/colorPicker.css'
import './styles/drawer.css'
import './styles/checkbox.css'
import './styles/datePicker.css'
import './styles/divider.css'
import './styles/dropdown.css'
import './styles/empty.css'
import './styles/floatButton.css'
import './styles/pagination.css'
import './styles/global.css'
import './styles/list.css'
import './styles/modal.css'
import './styles/message.css'
import './styles/popconfirm.css'
import './styles/popover.css'
import './styles/notification.css'
import './styles/descriptions.css'
import './styles/radio.css'
import './styles/segmented.css'
import './styles/select.css'
import './styles/steps.css'
import './styles/skeleton.css'
import './styles/switch.css'
import './styles/upload.css'
import './styles/table.css'
import './styles/tabs.css'
import './styles/tag.css'
import './styles/tooltip.css'
import './styles/typography.css'
import './styles/treeSelect.css'
import './styles/input.css'
import './styles/progress.css'
import './styles/inputNumber.css'
import './styles/slider.css'
import 'antd/dist/reset.css'
import { App, ConfigProvider } from 'antd'
import type { DirectionType } from 'antd/es/config-provider'
import type { Locale } from 'antd/es/locale'
import type { AliasToken } from 'antd/es/theme/internal'
import { createContext, type PropsWithChildren, useContext, useEffect } from 'react'
import { Empty } from './Empty'
import { getColors } from './helpers/colorsHelper'

type Token = Pick<
  AliasToken,
  | 'fontFamily'
  | 'borderRadiusXS'
  | 'borderRadiusSM'
  | 'borderRadius'
  | 'borderRadiusLG'
  | 'blue1'
  | 'blue2'
  | 'blue3'
  | 'blue4'
  | 'blue5'
  | 'blue6'
  | 'blue7'
  | 'blue8'
  | 'blue9'
  | 'blue10'
  | 'green1'
  | 'green2'
  | 'green3'
  | 'green4'
  | 'green5'
  | 'green6'
  | 'green7'
  | 'green8'
  | 'green9'
  | 'green10'
  | 'orange1'
  | 'orange2'
  | 'orange3'
  | 'orange4'
  | 'orange5'
  | 'orange6'
  | 'orange7'
  | 'orange8'
  | 'orange9'
  | 'orange10'
  | 'red1'
  | 'red2'
  | 'red3'
  | 'red4'
  | 'red5'
  | 'red6'
  | 'red7'
  | 'red8'
  | 'red9'
  | 'red10'
  | 'purple1'
  | 'purple2'
  | 'purple3'
  | 'purple4'
  | 'purple5'
  | 'purple6'
  | 'purple7'
  | 'purple8'
  | 'purple9'
  | 'purple10'
  | 'magenta1'
  | 'magenta2'
  | 'magenta3'
  | 'magenta4'
  | 'magenta5'
  | 'magenta6'
  | 'magenta7'
  | 'magenta8'
  | 'magenta9'
  | 'magenta10'
  | 'lime1'
  | 'lime2'
  | 'lime3'
  | 'lime4'
  | 'lime5'
  | 'lime6'
  | 'lime7'
  | 'lime8'
  | 'lime9'
  | 'lime10'
  | 'gold1'
  | 'gold2'
  | 'gold3'
  | 'gold4'
  | 'gold5'
  | 'gold6'
  | 'gold7'
  | 'gold8'
  | 'gold9'
  | 'gold10'
  | 'geekblue1'
  | 'geekblue2'
  | 'geekblue3'
  | 'geekblue4'
  | 'geekblue5'
  | 'geekblue6'
  | 'geekblue7'
  | 'geekblue8'
  | 'geekblue9'
  | 'geekblue10'
  | 'cyan1'
  | 'cyan2'
  | 'cyan3'
  | 'cyan4'
  | 'cyan5'
  | 'cyan6'
  | 'cyan7'
  | 'cyan8'
  | 'cyan9'
  | 'cyan10'
  | 'colorError'
  | 'colorErrorBg'
  | 'colorErrorHover'
  | 'colorErrorBgFilledHover'
  | 'colorErrorBorderHover'
  | 'colorErrorActive'
  | 'colorErrorBgActive'
  | 'colorSuccess'
  | 'colorSuccessHover'
  | 'colorSuccessActive'
  | 'colorSuccessBg'
  | 'colorSuccessBgHover'
  | 'colorSuccessBorder'
  | 'colorSuccessBorderHover'
  | 'colorSuccessText'
  | 'colorSuccessTextHover'
  | 'colorSuccessTextActive'
  | 'colorWarning'
  | 'colorWarningHover'
  | 'colorWarningActive'
  | 'colorWarningBg'
  | 'colorWarningBgHover'
  | 'colorWarningBorder'
  | 'colorWarningBorderHover'
  | 'colorWarningText'
  | 'colorWarningTextHover'
  | 'colorWarningTextActive'
  | 'colorWarningOutline'
  | 'colorText'
  | 'colorTextSecondary'
  | 'colorTextTertiary'
  | 'colorTextQuaternary'
  | 'colorTextHeading'
  | 'colorTextLabel'
  | 'colorTextDescription'
  | 'colorTextDisabled'
  | 'colorTextPlaceholder'
  | 'colorTextLightSolid'
  | 'colorPrimary'
  | 'colorPrimaryHover'
  | 'colorPrimaryActive'
  | 'colorPrimaryBg'
  | 'colorPrimaryBgHover'
  | 'colorPrimaryBorder'
  | 'colorPrimaryBorderHover'
  | 'colorPrimaryText'
  | 'colorPrimaryTextHover'
  | 'colorPrimaryTextActive'
  | 'colorLink'
  | 'colorLinkHover'
  | 'colorLinkActive'
  | 'colorBorder'
  | 'colorBorderSecondary'
  | 'colorBgLayout'
  | 'colorBgSpotlight'
  | 'colorBgContainerDisabled'
  | 'colorBgTextHover'
  | 'colorBgTextActive'
> & {
  primary1: string
  primary2: string
  primary3: string
  primary4: string
  primary5: string
  primary6: string
  primary7: string
  primary8: string
  primary9: string
  primary10: string
  colorDark: string
  colorDarkBg: string
  colorDarkBorder: string
}

type UiBaseProviderProps = PropsWithChildren<{
  locale: Locale | undefined
  colorPrimary?: string
  colorDark?: string
  direction: DirectionType
}>

export const UiBaseProvider = ({
  colorPrimary,
  colorDark,
  locale,
  direction,
  children,
}: UiBaseProviderProps) => {
  useEffect(() => {
    Object.entries(getColors(colorPrimary, colorDark)).forEach(([colorName, colorValue]) => {
      document.documentElement.style.setProperty(`--${colorName.replace(/\//g, '-')}`, colorValue)
    })
  }, [colorPrimary, colorDark])

  const token = getTokens(colorPrimary, colorDark)

  return (
    <App>
      <UiBaseInnerProvider token={token} locale={locale} direction={direction}>
        <ConfigProvider
          componentSize='large'
          locale={locale}
          direction={direction}
          renderEmpty={() => <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />}
          theme={{
            cssVar: false,
            hashed: false,
            token,
            components: {
              Alert: {
                colorWarningBg: '#FEF4ED',
                colorWarningBorder: '#FDD3B7',
                colorWarning: '#FA914B',
              },
              Avatar: {
                containerSizeLG: 44,
              },
              Typography: {
                fontSizeHeading1: 32,
                fontSizeHeading2: 28,
                fontSizeHeading3: 24,
                fontSizeHeading4: 20,
                fontSizeHeading5: 16,
                titleMarginBottom: 0,
                titleMarginTop: 0,
                lineHeight: 1.6,
                lineHeightHeading1: 1.2,
                lineHeightHeading2: 1.2,
                lineHeightHeading3: 1.2,
                lineHeightHeading4: 1.2,
                lineHeightHeading5: 1.2,
              },
              Badge: {
                textFontWeight: 'semibold',
              },
              Table: {
                rowHoverBg: '#9DB0DF1A',
                fixedHeaderSortActiveBg: '#9DB0DF1A',
                headerFilterHoverBg: '#9DB0DF1A',
                headerSortHoverBg: '#9DB0DF1A',
                headerSplitColor: '#9DB0DF1A',
              },
              Tabs: {
                horizontalMargin: '0',
                itemColor: '#547599',
              },
              Divider: {
                textPaddingInline: 12,
                colorSplit: '#E6ECF9',
              },
              Input: {
                inputFontSizeSM: 14,
                inputFontSize: 14,
                inputFontSizeLG: 14,
                paddingBlockLG: 10.5,
                borderRadiusSM: token.borderRadiusSM,
                borderRadius: token.borderRadius,
                borderRadiusLG: token.borderRadiusLG,
                activeShadow: '0 0 0 2px rgba(14, 154, 247, 0.10)',
                addonBg: '#ffffff',
                colorWarningBorderHover: token.colorWarningHover,
              },
              Select: {
                singleItemHeightLG: 44,
                multipleItemHeightLG: 36,
                fontSizeLG: 14,
                multipleItemBg: token.blue1,
                colorIcon: token.blue5,
                optionActiveBg: token.blue1,
                optionSelectedBg: token.blue1,
              },
              QRCode: {
                colorSplit: '#E6ECF9',
              },
              Collapse: {
                headerBg: '#fff',
                fontSizeLG: 14,
              },
              List: {
                colorBorder: '#E6ECF9',
                colorSplit: '#E6ECF9',
              },
              Skeleton: {
                gradientFromColor: '#9DB0DF1A',
                gradientToColor: '#9DB0DF33',
              },
              Descriptions: {
                labelBg: 'rgba(157, 176, 223, 0.02)',
              },
              Spin: {
                colorBgMask: '#062D46B2',
              },
              DatePicker: {
                fontSizeLG: 14,
                cellHoverBg: '#E6F3FF',
                controlHeight: 32,
                controlHeightLG: 44,
                controlHeightSM: 24,
                borderRadiusSM: token.borderRadiusSM,
                borderRadius: token.borderRadius,
                borderRadiusLG: token.borderRadiusLG,
                colorWarningBorderHover: token.colorWarningHover,
              },
              InputNumber: {
                borderRadiusSM: token.borderRadiusSM,
                borderRadius: token.borderRadius,
                borderRadiusLG: token.borderRadiusLG,
                controlHeight: 32,
                controlHeightLG: 44,
                controlHeightSM: 24,
              },
              Checkbox: {
                borderRadiusSM: token.borderRadiusXS,
              },
              Button: {
                fontSizeLG: 14,
                fontWeight: 700,
                colorPrimaryText: token.colorPrimaryText,
                colorPrimaryHover: token.colorPrimaryHover,
                colorPrimaryActive: token.colorPrimaryActive,
                colorBorder: token.colorBorder,
                dangerShadow: 'none',
                borderColorDisabled: '#ffffff00',
                textHoverBg: '#ffffff00',
                colorBgTextActive: '#ffffff00',
                textTextActiveColor: token.colorPrimaryActive,
                textTextHoverColor: token.colorPrimaryHover,
              },
              Empty: {
                colorTextDescription: '#92B4DB',
              },
              Switch: {
                handleShadow: 'none',
              },
              Tag: {
                defaultBg: '#9DB0DF26',
              },
              Modal: {
                colorBgMask: '#062D46B2',
                borderRadiusLG: 20,
              },
              Progress: {
                circleIconFontSize: '32px',
                circleTextFontSize: '20px',
              },
              Dropdown: {
                controlItemBgHover: '#9DB0DF26',
              },
              Steps: {
                navArrowColor: '#CDDDEE',
                fontSizeSM: 14,
                colorTextLabel: token.colorTextDescription,
              },
              Calendar: {
                controlItemBgHover: 'rgba(157, 176, 223, 0.15)',
                monthControlWidth: 80,
              },
              Slider: {
                // rail
                railSize: 8,
                trackBg: '#0085FF',
                trackHoverBg: '#0085FF',
                railBg: 'rgba(157, 176, 223, 0.15)',
                railHoverBg: 'rgba(157, 176, 223, 0.20)',

                // handle
                handleColor: '#0085FF',
                handleActiveColor: '#0085FF',
                colorPrimaryBorderHover: '#0085FF', // handle color on hover
                lineWidthFocus: 2,
                handleLineWidthHover: 4,
                handleSize: 10,
                handleSizeHover: 12,
                handleActiveOutlineColor: '#00000000', // transparent -- outline should not be visible
                handleColorDisabled: '#92B4DB',
                handleLineWidth: 2,

                // slider marks
                dotSize: 12,
                dotBorderColor: 'rgba(157, 176, 223, 0.15)',
                dotActiveBorderColor: '#0085FF',
                colorFillContentHover: 'rgba(157, 176, 223, 0.20)',
              },
              TreeSelect: {
                nodeHoverBg: '#9DB0DF26',
                controlHeightLG: 44,
                controlHeight: 32,
                controlHeightSM: 24,
              },
              Radio: {
                dotSize: 8,
                controlHeightLG: 44,
                controlHeight: 32,
                controlHeightSM: 24,
              },
              FloatButton: {
                controlHeightLG: 44,
              },
              Drawer: {
                colorBgMask: 'rgba(6, 45, 70, 0.7)',
              },
            },
          }}
        >
          {children}
        </ConfigProvider>
      </UiBaseInnerProvider>
    </App>
  )
}

type UiBaseContextProps = {
  token: Token
  locale: Locale | undefined
  direction: DirectionType
}

type UiBaseInnerProviderProps = PropsWithChildren<UiBaseContextProps>

const UiBaseContext = createContext<UiBaseContextProps>({
  token: {} as Token,
  locale: undefined,
  direction: 'ltr',
})

const UiBaseInnerProvider = ({ children, ...props }: UiBaseInnerProviderProps) => (
  <UiBaseContext.Provider value={props}>{children}</UiBaseContext.Provider>
)

export const useUiBaseConfig = () => useContext(UiBaseContext)

const getTokens: (colorPrimary?: string, colorDark?: string) => Token = (
  colorPrimary,
  colorDark
) => {
  const colors = getColors(colorPrimary, colorDark)
  const tokens: Token = {
    fontFamily: 'Inter, sans-serif',
    borderRadiusXS: 4,
    borderRadiusSM: 6,
    borderRadius: 8,
    borderRadiusLG: 12,
    //
    primary1: colors['Colors/Base/Primary/1'],
    primary2: colors['Colors/Base/Primary/2'],
    primary3: colors['Colors/Base/Primary/3'],
    primary4: colors['Colors/Base/Primary/4'],
    primary5: colors['Colors/Base/Primary/5'],
    primary6: colors['Colors/Base/Primary/6'],
    primary7: colors['Colors/Base/Primary/7'],
    primary8: colors['Colors/Base/Primary/8'],
    primary9: colors['Colors/Base/Primary/9'],
    primary10: colors['Colors/Base/Primary/10'],
    //
    blue1: colors['Colors/Base/Blue/1'],
    blue2: colors['Colors/Base/Blue/2'],
    blue3: colors['Colors/Base/Blue/3'],
    blue4: colors['Colors/Base/Blue/4'],
    blue5: colors['Colors/Base/Blue/5'],
    blue6: colors['Colors/Base/Blue/6'],
    blue7: colors['Colors/Base/Blue/7'],
    blue8: colors['Colors/Base/Blue/8'],
    blue9: colors['Colors/Base/Blue/9'],
    blue10: colors['Colors/Base/Blue/10'],
    green1: colors['Colors/Base/Green/1'],
    green2: colors['Colors/Base/Green/2'],
    green3: colors['Colors/Base/Green/3'],
    green4: colors['Colors/Base/Green/4'],
    green5: colors['Colors/Base/Green/5'],
    green6: colors['Colors/Base/Green/6'],
    green7: colors['Colors/Base/Green/7'],
    green8: colors['Colors/Base/Green/8'],
    green9: colors['Colors/Base/Green/9'],
    green10: colors['Colors/Base/Green/10'],
    orange1: colors['Colors/Base/Orange/1'],
    orange2: colors['Colors/Base/Orange/2'],
    orange3: colors['Colors/Base/Orange/3'],
    orange4: colors['Colors/Base/Orange/4'],
    orange5: colors['Colors/Base/Orange/5'],
    orange6: colors['Colors/Base/Orange/6'],
    orange7: colors['Colors/Base/Orange/7'],
    orange8: colors['Colors/Base/Orange/8'],
    orange9: colors['Colors/Base/Orange/9'],
    orange10: colors['Colors/Base/Orange/10'],
    red1: colors['Colors/Base/Red/1'],
    red2: colors['Colors/Base/Red/2'],
    red3: colors['Colors/Base/Red/3'],
    red4: colors['Colors/Base/Red/4'],
    red5: colors['Colors/Base/Red/5'],
    red6: colors['Colors/Base/Red/6'],
    red7: colors['Colors/Base/Red/7'],
    red8: colors['Colors/Base/Red/8'],
    red9: colors['Colors/Base/Red/9'],
    red10: colors['Colors/Base/Red/10'],
    purple1: colors['Colors/Base/Purple/1'],
    purple2: colors['Colors/Base/Purple/2'],
    purple3: colors['Colors/Base/Purple/3'],
    purple4: colors['Colors/Base/Purple/4'],
    purple5: colors['Colors/Base/Purple/5'],
    purple6: colors['Colors/Base/Purple/6'],
    purple7: colors['Colors/Base/Purple/7'],
    purple8: colors['Colors/Base/Purple/8'],
    purple9: colors['Colors/Base/Purple/9'],
    purple10: colors['Colors/Base/Purple/10'],
    magenta1: colors['Colors/Base/Magenta/1'],
    magenta2: colors['Colors/Base/Magenta/2'],
    magenta3: colors['Colors/Base/Magenta/3'],
    magenta4: colors['Colors/Base/Magenta/4'],
    magenta5: colors['Colors/Base/Magenta/5'],
    magenta6: colors['Colors/Base/Magenta/6'],
    magenta7: colors['Colors/Base/Magenta/7'],
    magenta8: colors['Colors/Base/Magenta/8'],
    magenta9: colors['Colors/Base/Magenta/9'],
    magenta10: colors['Colors/Base/Magenta/10'],
    lime1: colors['Colors/Base/Lime/1'],
    lime2: colors['Colors/Base/Lime/2'],
    lime3: colors['Colors/Base/Lime/3'],
    lime4: colors['Colors/Base/Lime/4'],
    lime5: colors['Colors/Base/Lime/5'],
    lime6: colors['Colors/Base/Lime/6'],
    lime7: colors['Colors/Base/Lime/7'],
    lime8: colors['Colors/Base/Lime/8'],
    lime9: colors['Colors/Base/Lime/9'],
    lime10: colors['Colors/Base/Lime/10'],
    gold1: colors['Colors/Base/Gold/1'],
    gold2: colors['Colors/Base/Gold/2'],
    gold3: colors['Colors/Base/Gold/3'],
    gold4: colors['Colors/Base/Gold/4'],
    gold5: colors['Colors/Base/Gold/5'],
    gold6: colors['Colors/Base/Gold/6'],
    gold7: colors['Colors/Base/Gold/7'],
    gold8: colors['Colors/Base/Gold/8'],
    gold9: colors['Colors/Base/Gold/9'],
    gold10: colors['Colors/Base/Gold/10'],
    geekblue1: colors['Colors/Base/Geekblue/1'],
    geekblue2: colors['Colors/Base/Geekblue/2'],
    geekblue3: colors['Colors/Base/Geekblue/3'],
    geekblue4: colors['Colors/Base/Geekblue/4'],
    geekblue5: colors['Colors/Base/Geekblue/5'],
    geekblue6: colors['Colors/Base/Geekblue/6'],
    geekblue7: colors['Colors/Base/Geekblue/7'],
    geekblue8: colors['Colors/Base/Geekblue/8'],
    geekblue9: colors['Colors/Base/Geekblue/9'],
    geekblue10: colors['Colors/Base/Geekblue/10'],
    cyan1: colors['Colors/Base/Cyan/1'],
    cyan2: colors['Colors/Base/Cyan/2'],
    cyan3: colors['Colors/Base/Cyan/3'],
    cyan4: colors['Colors/Base/Cyan/4'],
    cyan5: colors['Colors/Base/Cyan/5'],
    cyan6: colors['Colors/Base/Cyan/6'],
    cyan7: colors['Colors/Base/Cyan/7'],
    cyan8: colors['Colors/Base/Cyan/8'],
    cyan9: colors['Colors/Base/Cyan/9'],
    cyan10: colors['Colors/Base/Cyan/10'],
    colorError: colors['Colors/Brand/Error/colorError'],
    colorErrorBg: colors['Colors/Brand/Error/colorErrorBg'],
    colorErrorHover: colors['Colors/Brand/Error/colorErrorHover'],
    colorErrorBgFilledHover: colors['Colors/Brand/Error/colorErrorHover'], //!!!
    colorErrorBorderHover: colors['Colors/Brand/Error/colorErrorBorderHover'],
    colorErrorActive: colors['Colors/Brand/Error/colorErrorActive'],
    colorErrorBgActive: colors['Colors/Brand/Error/colorErrorActive'], //!!!
    colorSuccess: colors['Colors/Brand/Success/colorSuccess'],
    colorSuccessHover: colors['Colors/Brand/Success/colorSuccessHover'],
    colorSuccessActive: colors['Colors/Brand/Success/colorSuccessActive'],
    colorSuccessBg: colors['Colors/Brand/Success/colorSuccessBg'],
    colorSuccessBgHover: colors['Colors/Brand/Success/colorSuccessBgHover'],
    colorSuccessBorder: colors['Colors/Brand/Success/colorSuccessBorder'],
    colorSuccessBorderHover: colors['Colors/Brand/Success/colorSuccessBorderHover'],
    colorSuccessText: colors['Colors/Brand/Success/colorSuccessText'],
    colorSuccessTextHover: colors['Colors/Brand/Success/colorSuccessTextHover'],
    colorSuccessTextActive: colors['Colors/Brand/Success/colorSuccessTextActive'],
    colorWarning: colors['Colors/Brand/Warning/colorWarning'],
    colorWarningHover: colors['Colors/Brand/Warning/colorWarningHover'],
    colorWarningActive: colors['Colors/Brand/Warning/colorWarningActive'],
    colorWarningBg: colors['Colors/Brand/Warning/colorWarningBg'],
    colorWarningBgHover: colors['Colors/Brand/Warning/colorWarningBgHover'],
    colorWarningBorder: colors['Colors/Brand/Warning/colorWarningBorder'],
    colorWarningBorderHover: colors['Colors/Brand/Warning/colorWarningBorderHover'],
    colorWarningText: colors['Colors/Brand/Warning/colorWarningText'],
    colorWarningTextHover: colors['Colors/Brand/Warning/colorWarningTextHover'],
    colorWarningTextActive: colors['Colors/Brand/Warning/colorWarningTextActive'],
    colorWarningOutline: colors['Colors/Brand/Warning/colorWarningOutline'],
    colorText: colors['Colors/Neutral/Text/colorText'],
    colorTextSecondary: colors['Colors/Neutral/Text/colorTextSecondary'],
    colorTextTertiary: colors['Colors/Neutral/Text/colorTextTertiary'],
    colorTextQuaternary: colors['Colors/Neutral/Text/colorTextQuaternary'],
    colorTextHeading: colors['Colors/Neutral/Text/colorTextHeading'],
    colorTextLabel: colors['Colors/Neutral/Text/colorTextLabel'],
    colorTextDescription: colors['Colors/Neutral/Text/colorTextDescription'],
    colorTextDisabled: colors['Colors/Neutral/Text/colorTextDisabled'],
    colorTextPlaceholder: colors['Colors/Neutral/Text/colorTextPlaceholder'],
    colorTextLightSolid: colors['Colors/Neutral/Text/colorTextLightSolid'],
    colorPrimary: colors['Colors/Brand/Primary/colorPrimary'],
    colorPrimaryHover: colors['Colors/Brand/Primary/colorPrimaryHover'],
    colorPrimaryActive: colors['Colors/Brand/Primary/colorPrimaryActive'],
    colorPrimaryBg: colors['Colors/Brand/Primary/colorPrimaryBg'],
    colorPrimaryBgHover: colors['Colors/Brand/Primary/colorPrimaryBgHover'],
    colorPrimaryBorder: colors['Colors/Brand/Primary/colorPrimaryBorder'],
    colorPrimaryBorderHover: colors['Colors/Brand/Primary/colorPrimaryBorderHover'],
    colorPrimaryText: colors['Colors/Brand/Primary/colorPrimaryText'],
    colorPrimaryTextHover: colors['Colors/Brand/Primary/colorPrimaryTextHover'],
    colorPrimaryTextActive: colors['Colors/Brand/Primary/colorPrimaryTextActive'],
    colorLink: colors['Colors/Brand/Link/colorLink'],
    colorLinkHover: colors['Colors/Brand/Link/colorLinkHover'],
    colorLinkActive: colors['Colors/Brand/Link/colorLinkActive'],
    colorBorder: colors['Colors/Neutral/Border/colorBorder'],
    colorBorderSecondary: colors['Colors/Neutral/Border/colorBorderSecondary'],
    colorBgLayout: colors['Colors/Neutral/Bg/colorBgLayout'],
    colorBgSpotlight: colors['Colors/Neutral/Bg/colorBgSpotlight'],
    colorBgContainerDisabled: colors['Colors/Neutral/Bg/colorBgContainerDisabled'],
    colorBgTextHover: colors['Colors/Neutral/Bg/colorBgTextHover'],
    colorBgTextActive: colors['Colors/Neutral/Bg/colorBgTextActive'],
    colorDark: colors['Colors/Brand/Dark/colorDark'],
    colorDarkBg: colors['Colors/Brand/Dark/colorDarkBg'],
    colorDarkBorder: colors['Colors/Brand/Dark/colorDarkBorder'],
  }
  return tokens
}
